import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cad75a64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "dropdown_sheet" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "sub-items"
}
const _hoisted_4 = ["onClick"]

import { useRouter } from 'vue-router'
import { ref } from 'vue'
import useToggleLanguage from '@/utils/useToggleLanguage'
import routeHash from '@/constant/router_hash'
import Mitt from '@/utils/mitt'


const __default__ = {
  name: 'DropdownSheet'
}

interface RouteItem {
  path: string
  title: string
  children?: RouteItem[]
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    routes: {}
  },
  emits: ["onClose"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter()
const emits = __emit


const { onToggleLanguage } = useToggleLanguage()
const expandedPath = ref<string | null>(null)

const onSelectLanguage = () => {
    onToggleLanguage()
    emits("onClose")
}

const onSelect = (path: string) => {
  router.push(path)
  emits("onClose")
}

const onSelectItem = (item: RouteItem) => {
  if (item.children?.length) {
    expandedPath.value = expandedPath.value === item.path ? null : item.path
    return
  }
  onSelect(item.path)
}

const onSelectChild = (path: string) => {
  if (path.startsWith("/")) {
    onSelect(path)
    return
  }
  setTimeout(() => Mitt.emit(path), 0)
  switch (path) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      onSelect("/solution")
      return
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      onSelect("/service")
      return
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      onSelect("/product")
      return
    case routeHash.CONTACT_US:
      onSelect("/company")
      return
    default:
      onSelect(path)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "route-group",
        key: item.title
      }, [
        _createElementVNode("div", {
          class: "item",
          onClick: ($event: any) => (onSelectItem(item))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.title), 1),
          _createVNode(_component_van_icon, {
            name: item.children?.length ? 'arrow-down' : 'arrow',
            class: _normalizeClass({ expanded: expandedPath.value === item.path })
          }, null, 8, ["name", "class"])
        ], 8, _hoisted_2),
        (item.children?.length && expandedPath.value === item.path)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: child.title,
                  type: "button",
                  class: "sub-item",
                  onClick: ($event: any) => (onSelectChild(child.path))
                }, _toDisplayString(child.title), 9, _hoisted_4))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: "item",
      onClick: onSelectLanguage
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('navbar.PORTAL')), 1),
      _createVNode(_component_van_icon, { name: "arrow" })
    ])
  ]))
}
}

})